module.exports = __webpack_public_path__ + "img/lamasf.1bde699b.png";